import { render, staticRenderFns } from "./ThirdPartyForm.vue?vue&type=template&id=76c0849a&scoped=true&"
import script from "./ThirdPartyForm.vue?vue&type=script&lang=ts&"
export * from "./ThirdPartyForm.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdPartyForm.vue?vue&type=style&index=0&id=76c0849a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0849a",
  null
  
)

export default component.exports